<button
  #button
  class="checkin__btn checkin__btn__round"
  [ngClass]="customClass"
  [disabled]="disabled">
  <span>{{ text | translate:translateParams }}</span>
  <i *ngIf="icon" [ngClass]="icon"></i>
</button>
